import React, { useState, useEffect, useRef } from 'react';
import * as S from './CustomTimeInput.style';

const CustomTimeInput = ({ value = '09:30', onChange, ...props }) => {
	const [hours, setHours] = useState(value?.split(':')[0] || '09');
	const [minutes, setMinutes] = useState(value?.split(':')[1] || '30');
	// 스크롤 감도 누적(2틱에 1단계 변경)
	const hoursWheelAccumRef = useRef(0);
	const minutesWheelAccumRef = useRef(0);

	useEffect(() => {
		const timeString = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
		if (onChange) {
			onChange(timeString);
		}
	}, [hours, minutes, onChange]);

	const handleHoursChange = (e) => {
		const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 2);
		setHours(digitsOnly);
	};

	const handleHoursBlur = () => {
		let num = parseInt(hours || '0', 10);
		if (Number.isNaN(num)) num = 0;
		if (num < 0) num = 0;
		if (num > 23) num = 23;
		setHours(num.toString().padStart(2, '0'));
	};

	const handleMinutesChange = (e) => {
		const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 2);
		setMinutes(digitsOnly);
	};

	const handleMinutesBlur = () => {
		let num = parseInt(minutes || '0', 10);
		if (Number.isNaN(num)) num = 0;
		if (num < 0) num = 0;
		if (num > 59) num = 59;
		setMinutes(num.toString().padStart(2, '0'));
	};

	const incrementHours = (delta) => {
		let num = parseInt(hours === '' ? '0' : hours, 10);
		if (Number.isNaN(num)) num = 0;
		num = (num + delta + 24) % 24;
		setHours(num.toString().padStart(2, '0'));
	};

	const incrementMinutes = (delta) => {
		let num = parseInt(minutes === '' ? '0' : minutes, 10);
		if (Number.isNaN(num)) num = 0;
		num = (num + delta + 60) % 60;
		setMinutes(num.toString().padStart(2, '0'));
	};

	const handleHoursWheel = (e) => {
		e.stopPropagation();
		if (
			e.nativeEvent &&
			typeof e.nativeEvent.stopImmediatePropagation === 'function'
		) {
			e.nativeEvent.stopImmediatePropagation();
		}
		const delta = e.deltaY < 0 ? 1 : -1; // 위로 스크롤: 증가, 아래로: 감소
		hoursWheelAccumRef.current += delta;
		if (Math.abs(hoursWheelAccumRef.current) >= 2) {
			const step = hoursWheelAccumRef.current > 0 ? 1 : -1;
			incrementHours(step);
			hoursWheelAccumRef.current -= 2 * step;
		}
	};

	const handleMinutesWheel = (e) => {
		e.stopPropagation();
		if (
			e.nativeEvent &&
			typeof e.nativeEvent.stopImmediatePropagation === 'function'
		) {
			e.nativeEvent.stopImmediatePropagation();
		}
		const delta = e.deltaY < 0 ? 1 : -1;
		minutesWheelAccumRef.current += delta;
		if (Math.abs(minutesWheelAccumRef.current) >= 2) {
			const step = minutesWheelAccumRef.current > 0 ? 1 : -1;
			incrementMinutes(step);
			minutesWheelAccumRef.current -= 2 * step;
		}
	};

	return (
		<S.Container {...props}>
			<S.Input
				type='text'
				value={hours}
				onChange={handleHoursChange}
				onWheel={handleHoursWheel}
				onWheelCapture={handleHoursWheel}
				onBlur={handleHoursBlur}
				maxLength='2'
				placeholder='00'
				inputMode='numeric'
				pattern='[0-9]*'
				autoComplete='off'
			/>
			<S.Separator>:</S.Separator>
			<S.Input
				type='text'
				value={minutes}
				onChange={handleMinutesChange}
				onWheel={handleMinutesWheel}
				onWheelCapture={handleMinutesWheel}
				onBlur={handleMinutesBlur}
				maxLength='2'
				placeholder='00'
				inputMode='numeric'
				pattern='[0-9]*'
				autoComplete='off'
			/>
		</S.Container>
	);
};

export default CustomTimeInput;
